import { useConvexAuth } from "convex/react";
import { Navigate, Outlet } from "react-router";
import { AdminNavbar } from "./AdminNavbar";

export function AdminAuthGuard() {
  const { isLoading, isAuthenticated } = useConvexAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex min-h-screen w-full flex-col overflow-x-hidden">
      <AdminNavbar />
      <main className="flex-1 w-full min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
